import color from "../../constants/color";

const style = {
  title: {
    fontSize: "18px",
    fontWeight: 600,
    color: color.text,
  },
  alert: {
    mb: 2,
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 2,
    py: 0.75,
  },
  label: {
    fontSize: "13px",
    color: color.lightText,
  },
  value: {
    fontSize: "14px",
    fontWeight: 500,
    color: color.text,
  },
  total: {
    fontSize: "20px",
    fontWeight: 600,
    color: color.text,
  },
  quantityBox: {
    py: 1,
  },
  quantityInput: {
    mt: 0.5,
    width: "100%",
  },
  divider: {
    my: 1.5,
  },
  note: {
    fontSize: "12px",
    color: color.lightText,
    mt: 1,
  },
  actions: {
    px: 3,
    pb: 2,
  },
  cancel: {
    textTransform: "none",
  },
  confirm: {
    textTransform: "none",
    borderRadius: "50px",
    px: 3,
  },
};

export default style;
